import { createVNode, defineComponent } from 'vue';
import Icon from '../components/Icon.vue';

export default (name) => {
  return defineComponent({
    render: () => createVNode(Icon, { name }, null, 0),
  });
};
